/**
 * Shared copy for the Excel-opening CTAs.
 *
 * These live in one place deliberately: the labels were duplicated at nine call
 * sites and drifted into six different strings, which is the drift this pill was
 * introduced to undo. Adding a tenth call site should mean importing these, not
 * retyping them.
 */
export const EXCEL_ANALYSIS_LABEL = 'Excel Analysis';
export const EXCEL_ANALYSIS_LOADING_LABEL = 'Generating…';

/** The all-directors combined workbook. */
export const COMBINED_ANALYSIS_LABEL = 'Combined Excel Analysis';

/**
 * Debt Details links out to the borrower's uploaded source document rather than
 * a generated analysis, so its pill names the document, not the analysis.
 * Scoped to that one surface on purpose — the other Excel CTAs keep
 * EXCEL_ANALYSIS_LABEL.
 */
export const REFERENCE_DOCUMENT_LABEL = 'Reference Document';
